(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DURATION = 220;

  // Cancel any in-flight animation on an answer element and clear inline styles.
  function clearAnimation(answer) {
    if (answer._faqDone) {
      answer.removeEventListener('transitionend', answer._faqDone);
      answer._faqDone = null;
    }
    if (answer._faqTimer) {
      clearTimeout(answer._faqTimer);
      answer._faqTimer = null;
    }
    answer.style.transition = '';
    answer.style.height = '';
  }

  // Animate an answer's height from `from`px to `to`px, then run onComplete.
  function animateHeight(answer, from, to, onComplete) {
    clearAnimation(answer);
    answer.style.height = from + 'px';
    answer.getBoundingClientRect(); // force reflow so the transition runs
    answer.style.transition = 'height ' + DURATION + 'ms ease';
    answer.style.height = to + 'px';

    var done = function (e) {
      if (e && (e.target !== answer || e.propertyName !== 'height')) return;
      clearAnimation(answer);
      if (onComplete) onComplete();
    };
    answer._faqDone = done;
    answer.addEventListener('transitionend', done);
    // Fallback: resolve state even if transitionend never fires.
    answer._faqTimer = setTimeout(done, DURATION + 50);
  }

  function openItem(item) {
    var answer = item.querySelector('.faq__answer');
    item.open = true;
    if (!answer) return;
    if (motionQuery.matches) { clearAnimation(answer); return; }
    animateHeight(answer, 0, answer.scrollHeight, null);
  }

  function closeItem(item) {
    var answer = item.querySelector('.faq__answer');
    if (!answer) { item.open = false; return; }
    if (motionQuery.matches) { item.open = false; return; }
    animateHeight(answer, answer.scrollHeight, 0, function () { item.open = false; });
  }

  // Collapse with no animation. Used for answers above the tapped question so the
  // scroll can be corrected in a single step instead of chasing a height animation.
  function closeItemInstant(item) {
    var answer = item.querySelector('.faq__answer');
    if (answer) clearAnimation(answer);
    item.open = false;
  }

  function initFaq(container) {
    var items = Array.prototype.slice.call(container.querySelectorAll('.faq__item'));
    items.forEach(function (item) {
      if (item._faqInit) return;
      item._faqInit = true;
      var summary = item.querySelector('.faq__question');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) {
          closeItem(item);
          return;
        }

        // Pin the tapped question in the viewport. Answers that sit *above* it
        // are collapsed instantly (they're off screen, so the animation isn't
        // seen anyway) and the scroll is corrected once — this avoids the page
        // jumping up and shoving the question off screen on mobile. Answers
        // below the tap animate normally; collapsing them never shifts the tap.
        var clickedIndex = items.indexOf(item);
        var anchorTop = summary.getBoundingClientRect().top;
        var collapsedAbove = false;

        items.forEach(function (other, idx) {
          if (other === item || !other.open) return;
          if (idx < clickedIndex) {
            closeItemInstant(other);
            collapsedAbove = true;
          } else {
            closeItem(other);
          }
        });
        openItem(item);

        if (collapsedAbove) {
          var delta = summary.getBoundingClientRect().top - anchorTop;
          if (delta) window.scrollBy(0, delta);
        }
      });
    });
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-faq]'))
      .forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-initialize when Shopify's theme editor (re)loads this section.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
